import { isJsonString } from "./json";

export const getMentionIds = (message) => {
    if (isJsonString(message)) {
        const obj = JSON.parse(message)
        const mention = Object.keys(obj.entityMap)
            .map(o => obj.entityMap[o])
            .filter(f => f.type === 'MENTION')
            .map(m => m.data.url)
        return mention
    } else {
        const commentSplit = message.split(/{([^}]+)}/g).filter(Boolean);
        return _(commentSplit)
            .filter(o => {
                const regEx = /\[([^\]]+)]/;
                return regEx.test(o);
            })
            .map(o => {
                return _.toNumber(o.match(/\((.*)\)/).pop());
            })
            .value();
    }
};

export const isMessageEmpty=(message)=>{
    try {
       const obj = JSON.parse(message)
       if(obj.blocks.length === 1 && !obj.blocks[0].text) {
          return 0
       } 
           return message.length
    }  catch(error){
        return 0
    }
  }